<template>
  <div>
    <bp-editor v-if="smsRef == 'mareba'" class="hidden-sm-and-down"></bp-editor>
    <web-editor
      v-if="smsRef != 'mareba'"
      class="hidden-sm-and-down"
    ></web-editor>

    <mobile-editor
      v-if="smsRef != 'mareba'"
      class="hidden-md-and-up"
    ></mobile-editor>
    <bp-mobile-editor
      v-if="smsRef == 'mareba'"
      class="hidden-md-and-up"
    ></bp-mobile-editor>
    <!-- <wahome-editor></wahome-editor> -->
  </div>
</template>

<script>
import MobileEditor from "./mobile.vue";
import BpMobileEditor from "./bp-mobile.vue";
// import WebEditor from "./cash.vue";
import BpEditor from "./buying-prices.vue";
import WebEditor from "./web.vue";
// import WebEditor from "./barcode-web.vue";
// import WahomeEditor from "./wahome-mobile.vue";
export default {
  components: {
    MobileEditor,
    BpMobileEditor,
    WebEditor,
    BpEditor,
    // WahomeEditor,
  },
  data() {
    return {
      smsRef: null,
    };
  },
  methods: {
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.smsRef = res.ResponseData.smsRef;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getGenSettings();
  },
};
</script>

<style lang="scss" scoped>
</style>